import React from 'react';
import { useIntl } from 'react-intl';
import { showSlidingDoorsInfoSheet } from 'ducks/sheets';
import styled from 'styled-components';
import { useAppDispatch } from 'ducks/hooks';
import SkapaInlineMessage, { InlineMessageVariantEnum } from 'ui/InlineMessage/SkapaInlineMessage';
import IncorrectIcon from '@ingka/ssr-icon/paths/incorrect';

const Box = styled.div`
  padding: 0 1.5rem 0 1.5rem;
`;

const Link = styled.button`
  background: none;
  border: none;
  padding: 0;
  text-decoration: underline;
  cursor: pointer;
  color: #000;
  font-size: 0.875rem;
  padding-left: 2.3rem;
  padding-top: 0.5rem;
`;

const SlidingDoorsInfoMessageMobileSwiper = () => {
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();

  const openSlidingDoorsInfoSheet = () => {
    dispatch(showSlidingDoorsInfoSheet());
  };
  return (
    <Box>
      <SkapaInlineMessage
        title={formatMessage({ id: 'storageone.slidingDoorsWarning' })}
        body={formatMessage({ id: 'storageone.slidingDoorsWarningText' })}
        variant={InlineMessageVariantEnum.NEGATIVE}
        ssrIcon={IncorrectIcon}
        subtle
      />
      <Link data-testid="sliding-doors-info-button" onClick={openSlidingDoorsInfoSheet}>
        {formatMessage({ id: 'storageone.slidingDoorsInfoButton' })}
      </Link>
    </Box>
  );
};
export default SlidingDoorsInfoMessageMobileSwiper;
